import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CcHeaderModule } from "cc-components-lib";
import { HeaderComponent } from "./header.component";
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [HeaderComponent],
  imports: [CommonModule, CcHeaderModule],
  exports: [HeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderModule {}
